export const styles = {
    container: {
        height: 'calc(100% - 60px)'
    }
};

export type ComponentJSSClasses = JSSClasses<typeof styles>;
